export enum MilestoneType {
  INITIAL = 'initial',
  REQUESTED = 'requested',
  LATER = 'later',
}
